import React from 'react';
import Joyride, { CallBackProps, STATUS } from 'react-joyride';
import { useTheme } from '../ThemeProvider';
import { useTour } from '../../context/TourContext';
import { reportsSteps } from './reportsSteps';

const ReportsTour: React.FC = () => {
  const { theme } = useTheme();
  const { runReportsTour, stopPageTour } = useTour();

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status, action } = data;

    // Handle close button or tour completion
    if (action === 'close' || status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      stopPageTour('reports');
    }
  };

  return (
    <Joyride
      steps={reportsSteps}
      run={runReportsTour}
      continuous
      showProgress
      showSkipButton
      disableOverlayClose={false}
      disableCloseOnEsc={false}
      hideCloseButton={false}
      spotlightClicks={true}
      scrollToFirstStep={true}
      scrollOffset={100}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          zIndex: 10000,
        },
        tooltip: {
          backgroundColor: theme === 'dark' ? 'hsl(220 13% 9%)' : '#fff',
          color: theme === 'dark' ? 'hsl(210 40% 98%)' : '#000',
        },
        buttonNext: {
          backgroundColor: theme === 'dark' ? 'hsl(210 40% 98%)' : 'hsl(222 29% 16%)',
          color: theme === 'dark' ? 'hsl(222 33% 15%)' : 'hsl(210 40% 98%)',
        },
        buttonBack: {
            color: theme === 'dark' ? 'hsl(210 40% 98%)' : '#000',
        },
        buttonSkip: {
            color: theme === 'dark' ? 'hsl(210 40% 98%)' : '#000',
        }
      }}
    />
  );
};

export default ReportsTour;
